import { useMutation } from "@apollo/client";
import { App, Form } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DELETE_PERIOD } from "./blockedPeriods.gql";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ADD_BLOCKED_PERIOD } from "./blockedPeriod.gql";
import { DateStateType } from "../../types/date";
import { DATE_FORMAT } from "../../constants/date";

const useBlockedPeriod = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { id: professionistId, fetchDoctorBlockedPeriods, blockedPeriods } = useCurrentUser();
  const [form] = Form.useForm();
  const [currentPeriod, setCurrentPeriod] = useState<DateStateType>(null);

  const [add, {
    loading
  }] = useMutation(
    ADD_BLOCKED_PERIOD,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        form.resetFields();
        fetchDoctorBlockedPeriods();
        message.success(t("apollo.success.addBlockedPeriod"));
      }
    },
  );

  const [remove, {
    loading: deleteLoading
  }] = useMutation(
    DELETE_PERIOD,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        fetchDoctorBlockedPeriods();
        message.success(t("apollo.success.deletePeriod"));
      }
    },
  );

  const onSubmit = async (values: any) => {
    add({
      variables: {
        id: Number(professionistId),
        from: values.period[0].format(DATE_FORMAT.FULL_DATE),
        to: values.period[1].format(DATE_FORMAT.FULL_DATE)
      }
    }).then((data) => {
      if ("data" in data) setCurrentPeriod(null);
    });
  };

  const onRemove = async (id: string) => remove({
    variables: {
      ids: [id]
    }
  });

  return {
    remove,
    loading,
    deleteLoading,
    currentPeriod,
    form,
    onSubmit,
    blockedPeriods,
    onRemove,
    setCurrentPeriod
  };
};

export default useBlockedPeriod;
